/* eslint-disable */
import { Fragment, useContext, useEffect, useState } from "react";

import { LocalizationContext } from "../App";
import { cn } from "../common/helpers/formatters";
import { Plus } from "../common/icons";
import { FaqModel, loadFAQ } from "../store/appSlice";
import { RootState, useAppDispatch, useAppSelector } from "../store/store";

const Faq = () => {
  const actionDispatch = useAppDispatch();
  const l10n = useContext(LocalizationContext);
  const [expandedFaq, setExpandedFaq] = useState<number | undefined>();
  const { appLanguage, faq: faqFromState } = useAppSelector((state: RootState) => state.app);
  const [faq, setFaq] = useState<FaqModel | undefined>(faqFromState?.[appLanguage ?? "de"]);
  const [filteredFaq, setFilteredFaq] = useState<FaqModel | undefined>(faq);

  const [isCollapsing, setIsCollapsing] = useState(false);

  useEffect(() => {
    actionDispatch(loadFAQ());
  }, []);

  useEffect(() => {
    if (faqFromState)
      setFaq(faqFromState[appLanguage ?? "de"]);
  }, [appLanguage, faqFromState]);

  useEffect(() => {
    if (faq)
      setFilteredFaq(faq);
  }, [faq]);

  const filterFAQ = (searchTerm: string) => {
    if (!searchTerm || searchTerm.length <= 2) setFilteredFaq(faq);
    else {
      var fFaq = Object.assign({}, faq);
      fFaq.pages = fFaq.pages.map((p) => {
        var newP = Object.assign({}, p);
        newP.categories = p.categories.map((c) => {
          var newC = Object.assign({}, c);
          newC.qa = c.qa.filter((qa) => {
            return (
              qa.q.toLocaleLowerCase().includes(searchTerm) ||
              qa.a.toLocaleLowerCase().includes(searchTerm)
            );
          });

          return newC;
        });

        newP.categories = newP.categories.filter((x) => x.qa.length > 0);

        return newP;
      });
      setFilteredFaq(fFaq);
    }
  };

  return (
    <>
      <h2>FAQ</h2>
      <div className="form-group">
        <label htmlFor="search">{l10n.label.searchFaq}</label>
        <input
          autoComplete="off"
          className="form-control"
          id="search"
          name="search"
          onChange={(val) => filterFAQ(val.target.value?.toLocaleLowerCase())}
          placeholder={l10n.label.searchFaq}
          title="Search"
          type="search"
        />
      </div>
      {filteredFaq?.pages?.map((page, idx) => (
        <div key={`p-${idx * 1000}`}>
          {page.categories.map((category, cidx) => (
            // mb-4 last:
            <div className="mt-12 first:mt-0 mb-0" key={`pc-${idx * 1000 + cidx * 100}`}>
              <h3
                className={cn(
                  "faq-category-title align-faq-section-title font-faq-section-title text-faq-section-title",
                  cidx > 0 ? "mt-8" : "mt-4"
                )}
              >
                {category.title}
              </h3>
              {/* first-of-type:border-none py-[20px] first-of-type:pt-0 last-of-type:pb-0 */}
              <div className="flex flex-col border-b-[1px] border-card-body">
                {category.qa.map((qa, qidx) => (
                  <Fragment key={`qw-${idx * 1000 + cidx * 100 + qidx}`}>
                    <div
                      // first-of-type:pt-0 last-of-type:pb-0
                      className={cn(
                        "flex justify-between items-center p-faq-item border-t-[1px] first-of-type:border-none border-card-body",
                        expandedFaq === idx * 1000 + cidx * 100 + qidx && "bg-faq-item-expanded text-faq-item-expanded-question"
                      )}
                      key={`q-${idx * 1000 + cidx * 100 + qidx}`}
                    >
                      <span>{qa.q}</span>
                      <button
                        aria-label="Expand"
                        className={cn(
                          "btn-faq !m-0 w-6 h-6 !delay-0 !duration-500",
                          expandedFaq === idx * 1000 + cidx * 100 + qidx &&
                            "expanded grayscale-0"
                        )}
                        onClick={() =>
                          setExpandedFaq(
                            idx * 1000 + cidx * 100 + qidx === expandedFaq
                              ? undefined
                              : idx * 1000 + cidx * 100 + qidx
                          )
                        }
                        type="button"
                      >
                        {/* stroke-btn-action */}
                        <Plus className={cn("w-6 h-6 stroke-1")} />
                      </button>
                    </div>
                    {expandedFaq === idx * 1000 + cidx * 100 + qidx && (
                      <div
                        className={cn(
                          "text-base p-faq-item !pt-0",
                          expandedFaq === idx * 1000 + cidx * 100 + qidx && "bg-faq-item-expanded",
                          // TODO: Try to implement transition like done in Bootstrap: https://getbootstrap.com/docs/5.3/components/collapse/ ("collapse transition-[height] duration-300 ease-in")
                        )}
                        key={`a-${idx * 1000 + cidx * 100 + qidx}`}
                      >
                        {qa.a}
                      </div>
                    )}
                  </Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default Faq;
